import 'amazon-connect-streams';
import React, { useRef, useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { LoadingSpinner } from '../../../components/common';

const ConnectCCP = ({ instance, setCall, setRecordingState, setPauseStopRecordingReason }) => {
    const [isLoading, setIsLoading] = useState(true);
    const ref = useRef();
    const formattedInstanceName = instance?.project.replace(/_/g, '-').toLowerCase();
    useEffect(() => {
        try {
            if (typeof window === 'undefined') throw new Error('window missing');
            if (typeof window.connect === 'undefined') throw new Error('global connect missing');

            window.connect.core.initCCP(ref.current, {
                ccpUrl: `https://${formattedInstanceName}.my.connect.aws/ccp-v2/`,
                loginPopup: true,
                loginPopupAutoClose: true,
                loginUrl: instance?.authlink,
                softphone: { allowFramedSoftphone: true },
            });
            window.connect.core.onAccessDenied(() => {
                setIsLoading(false);
            });
            window.connect.core.onInitialized(() => {
                setIsLoading(false);
                window.connect.contact((c) => {
                    c.onEnded(() => {
                        setCall && setCall(null);
                        setRecordingState && setRecordingState('STOPPED');
                        setPauseStopRecordingReason && setPauseStopRecordingReason('');
                    });
                    c.onMissed(() => {
                        setCall && setCall(null);
                        setRecordingState && setRecordingState('STOPPED');
                        setPauseStopRecordingReason && setPauseStopRecordingReason('');
                    });
                    c.onConnected((t) => {
                        setCall &&
                            setCall({
                                contactId: t.getContactId(),
                                initialContactId: t.getInitialContactId() || t.getContactId(),
                            });
                        setRecordingState && setRecordingState('RECORDING');
                        setPauseStopRecordingReason && setPauseStopRecordingReason('');
                    });
                    c.onAccepted((t) => {
                        setCall &&
                            setCall({
                                contactId: t.getContactId(),
                                initialContactId: t.getInitialContactId() || t.getContactId(),
                            });
                        setRecordingState && setRecordingState('RECORDING');
                        setPauseStopRecordingReason && setPauseStopRecordingReason('');
                    });
                });
            });
        } catch (e) {
            toast.error();
            console.error(e);
        }
        return () => {
            window.connect.core.terminate();
            ref.current = null;
        };
        //eslint-disable-next-line
    }, [formattedInstanceName, instance]);

    return (
        <>
            <div
                ref={ref}
                style={{
                    display: isLoading ? 'none' : 'block',
                    width: '100%',
                    height: '100%',
                    minWidth: 400,
                    maxHeight: 'calc(100vh - 160px)',
                }}
            />
            {isLoading ? <LoadingSpinner /> : <></>}
        </>
    );
};

export default ConnectCCP;
